import {DataStatus, FormControl, FormField} from 'platform/components';
import {Grid} from 'platform/foundation';

import {useGetBranchListQuery, useGetCurrenciesQuery} from '@dms/api/core';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

import {BranchOption, DefinitionFormType} from '../utils/types';

interface BranchSectionProps {
  edit: boolean;
  isSystem: boolean;
  control: FormControl<DefinitionFormType>;
}

export function BranchSection(props: BranchSectionProps) {
  const {data: currenciesData, isLoading: currenciesLoading} = useGetCurrenciesQuery();
  const {data: branchesData, isLoading: branchesLoading} = useGetBranchListQuery();

  const branchOptions: BranchOption[] =
    branchesData?.branchListItems.map((branch) => ({
      value: branch.id,
      label: branch.marketingName ?? '',
    })) ?? [];

  const currencyOptions =
    currenciesData?.map((currency) => ({
      value: currency.code,
      label: currency.name,
    })) ?? [];

  return (
    <DataStatus isLoading={currenciesLoading || branchesLoading}>
      <Grid columns={2}>
        <FormField
          control={props.control}
          name="branchId"
          type="choice"
          label={i18n.t('entity.branch.labels.branch')}
          options={branchOptions}
          isDisabled={props.edit}
          tooltip={i18n.t('entity.cashRegisterLimits.labels.branchTooltip')}
          data-testid={testIds.settings.cashLimits('branchId')}
        />
        <FormField
          control={props.control}
          name="currency"
          type="choice"
          label={i18n.t('general.labels.currency')}
          options={currencyOptions}
          isDisabled={props.isSystem}
          data-testid={testIds.settings.cashLimits('currency')}
        />
      </Grid>
    </DataStatus>
  );
}
